import { ItemStylingModel } from '../models/item/item-styling.model';

export const /** @type {?} */ ItemTemplates = {
  defaultTemplate: {
    property: {
      display: true,
      disable: false
    },
    style : new ItemStylingModel({
      container: {
        class: '',
        dynamicClass: ''
      },
      item: {
        class: 'item',
        dynamicClass: ''
      },
      selectedItem: {
        class: 'itemSelected',
        dynamicClass: ''
      },
    })
  }
}
